import { FC, useMemo } from 'react';

import { Col, Row } from 'antd';

import video from '../../assets/video/main-page-aplocast-main.mp4';

import { LandingParagraph, LandingTitle, LandingVideo } from './styled';

type TProps = {
  isMobile: boolean;
  scrollToBottom: () => void;
};

export const TitleBlock: FC<TProps> = ({ isMobile, scrollToBottom }) => {
  const gutter = useMemo<[number, number]>(
    () => (isMobile ? [10, 10] : [48, 48]),
    [isMobile],
  );

  return (
    <Row gutter={gutter} align='middle' justify='center'>
      <Col xs={24} md={12}>
        <LandingTitle>Описание программного обеспечения</LandingTitle>
        <LandingParagraph>
          Программа для ЭВМ «AploCast» предназначена для воспроизведения мультимедийного
          контента на устройствах Android и управления показом контента через
          централизованный сервер. Программа обеспечивает загрузку, хранение и
          воспроизведение видео- и графических файлов, формирование плейлистов и удалённое
          управление параметрами отображения.
        </LandingParagraph>
        <LandingParagraph>
          Программное обеспечение AploCast может использоваться для организации
          информационного и рекламного отображения контента на экранах в коммерческих и
          общественных пространствах.
        </LandingParagraph>
      </Col>
      <Col xs={24} md={12}>
        <LandingVideo src={video} autoPlay loop muted playsInline />
      </Col>
    </Row>
  );
};